import * as React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import "@/translations/config";
import "@/types/router";
import EnvironmentBanner from "@/components/environment-banner";
import { queryClient } from "@/utils/query-client";
import { Toaster } from "@/components/ui/toast";
import { router } from "@/router";
import "overlayscrollbars/styles/overlayscrollbars.css";

const env = (import.meta.env.VITE_ENV || "development").toLowerCase();

if (["qa", "staging", "production"].includes(env)) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [import.meta.env.VITE_SENTRY_TARGET_URL].filter(
      (t): t is string => Boolean(t),
    ),
    environment: env,
  });
}

function App() {
  return (
    <>
      <EnvironmentBanner env={env} />
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
      <Toaster />
    </>
  );
}

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

export default App;
